export default __webpack_public_path__ + "static/media/subtle_heart.6e158ef2.mp3";